import { render, staticRenderFns } from "./AllSenderIDs.vue?vue&type=template&id=8121ccd2&scoped=true&"
import script from "./AllSenderIDs.vue?vue&type=script&lang=ts&"
export * from "./AllSenderIDs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8121ccd2",
  null
  
)

export default component.exports